import { getCurrentUserModules } from "./getCurrentUserModules";
import { jwtDecode } from "jwt-decode";

export function getCurrentUserAccessLevel(subModuleName) {
  const token = localStorage.getItem("accessToken");
  const role = jwtDecode(token).role;
  const type = jwtDecode(token).user_type;
  
  if (role !== 'user' || type === 'administrator') return 3;
  
  const modulesData = getCurrentUserModules();
  if (!Array.isArray(modulesData)) return 0;

  for (const module of modulesData) {
    if (Array.isArray(module.subModules)) {
      const found = module.subModules.find(
        (sub) => sub.name === subModuleName
      );
      if (found) {
        return found.access_level ?? 0; // use 0 if null/undefined
      }
    }
  }

  return 0; // default if not found
}
